import React, {useEffect} from 'react';
import InputFilter from '../../Filters/InputFilter';
import SelectComponent from '../../Selects/SelectComponentFilt';
import {useTranslation} from 'react-i18next';
import TablePagination from '../../TablePagination';
import {useContext} from 'react';
import {Context} from '../../../Helpers/Auth';
import {useState} from 'react';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import Spinner from '../../../components/Spinner';
import {Collapse, initTE} from 'tw-elements';
import Datepicker from 'react-tailwindcss-datepicker';
import {getQuestionarios, getRepresentantes} from '../../../pages/requests';
import NotFound from '../../NotFound';
import axios from 'axios';
import moment from 'moment';
import {toast} from 'react-toastify';

function Table({
    onRowClick,
    loading,
    setLoading,
    representantes,
    simNao,
    filtroNumero,
    setFiltroNumero,
    filtroCliente,
    filtroData,
    setFiltroData,
    filtroDescricao,
    setFiltroDescricao,
    filtroVendedor,
    setFiltroVendedor,
    filtroNegocio,
    setFiltroNegocio,
    setFiltroCliente,
    filtroValidado,
    setFiltroValidado,
}) {
    const {t} = useTranslation();
    const {isCard, openCards, utilizador} = useContext(Context);

    initTE({Collapse});

    let lang;
    switch (localStorage.getItem('i18nextLng')) {
        case 'pt':
            lang = 'POR';
            break;
        case 'fr':
            lang = 'FRA';
            break;
        case 'en':
            lang = 'ENG';
            break;
        case 'es':
            lang = 'ES'; 
            break;
    }

    const ITEMS_PER_PAGE = 15;

    const [currentPage, setCurrentPage] = useState(1);
    const [totalLinhas, setTotalLinhas] = useState(0);
    const [questoes, setQuestoes] = useState([]);
    const [semDados, setSemDados] = useState(false);
    const FORMATO_DATA = 'YYYY-MM-DD';
    const FORMATO_DATA_COMPLETO = 'YYYY-MM-DD HH:mm:ss';

    const [isMobile, setIsMobile] = useState(false);

    const handleResize = () => {
        setIsMobile(window.innerWidth < 800);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);

        const controller = new AbortController();
        const signal = controller.signal;

        const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
        const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
        setQuestoes([]);
        setLoading(true);
        setSemDados(false);
        debugger;
        getQuestionarios(
            indexOfFirstItem,
            indexOfLastItem - 1,
            lang,
            signal,
            filtroNumero,
            filtroDescricao,
            filtroCliente,
            filtroData.startDate ?? '',
            filtroData.endDate ?? '',
            filtroVendedor?.value ?? '',
            filtroNegocio,
            filtroValidado?.value,
        )
            .then(res => {
                debugger;
                if (res.data.success) {
                    setQuestoes(res.data.questionarios);
                    setTotalLinhas(res.data.totalRegistos);
                    if (res.data.totalRegistos == 0) {
                        setSemDados(true);
                    }
                } else {
                    res.data.errorMessages.map(m =>
                        toast.error(m, {
                            position: 'top-right',
                            autoClose: 5000,
                        }),
                    );
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.log(error);
                }
            })
            .finally(() => {
                setLoading(false);
            });

        return () => {
            controller.abort();
        };
    }, [currentPage, filtroNumero, filtroDescricao, filtroCliente, filtroNegocio, filtroData.startDate, filtroVendedor, filtroValidado]);

    const filtrosAplicados = () => {
        return filtroNumero || filtroDescricao || filtroCliente || filtroNegocio || filtroData.startDate || filtroVendedor || filtroValidado;
    };

    function limparFiltros() {
        setFiltroNumero('');
        setFiltroDescricao('');
        setFiltroCliente('');
        setFiltroNegocio('');
        setFiltroData({startDate: null, endDate: null});
        setFiltroVendedor(null);
        setFiltroValidado(null);
    }

    return (
        <>
            <div>
                {isMobile || isCard ? (
                    <div>
                        {questoes?.map((dados, index) => (
                            <div key={index} className={`rounded-none border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                                <h2 className="mb-0" id="headingOne">
                                    <button
                                        className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                        type="button"
                                        data-te-collapse-init
                                        data-te-collapse-collapsed
                                        data-te-target={'#flush-collapseThree' + index}
                                        aria-expanded="false"
                                        aria-controls="flush-collapseThree">
                                        <div className="flex flex-row" onClick={() => onRowClick(dados)}>
                                            {dados.descricao}
                                        </div>
                                        <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                            </svg>
                                        </span>
                                    </button>
                                </h2>
                                <div
                                    id={'flush-collapseThree' + index}
                                    className={openCards ? 'visible' : '!visible hidden'}
                                    data-te-collapse-item
                                    aria-labelledby="flush-headingThree"
                                    data-te-parent="#accordionFlushExample">
                                    <div className="px-5 py-4">
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('numero')}:</div> {dados.id}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('cliente')}: </div> {dados.cliente.nomeCliente}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('data')}: </div> {dados.dataCriacao}
                                        </div>
                                        {/* <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('contacto')}: </div> {dados.contacto}
                                        </div> */}
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('vendedor')}: </div> {dados.representante.label}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('negocio')}: </div> {dados.negocio.nome}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('validado')}: </div> {dados.validado ? t('sim') : t('nao')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}

                        {loading && (
                            <div className="flex flex-row mt-14 justify-center">
                                <>
                                    <Spinner />
                                </>
                            </div>
                        )}

                        <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                            <div>
                                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                    {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                    <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalLinhas / ITEMS_PER_PAGE)}</span>
                                </span>

                                <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalLinhas}</span>
                                <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                            </div>
                            <TablePagination total={totalLinhas} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                        </nav>
                    </div>
                ) : (
                    <div className="relative min-h-[400px] overflow-x-auto shadow-md sm:rounded-[8px]">
                        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                                <tr>
                                    <th scope="col" className="px-6 py-3">
                                        {t('numero')}
                                        <InputFilter
                                            value={filtroNumero}
                                            onSearch={value => {
                                                setFiltroNumero(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                    </th>

                                    <th scope="col" className="px-6 py-3">
                                        {t('descricao')}
                                        <InputFilter
                                            value={filtroDescricao}
                                            onSearch={value => {
                                                setFiltroDescricao(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                    </th>

                                    <th scope="col" className="px-6 py-3 w-72">
                                        {t('cliente')}
                                        <InputFilter
                                            value={filtroCliente}
                                            onSearch={value => {
                                                setFiltroCliente(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                    </th>

                                    <th scope="col" className="px-6 py-3">
                                        {t('negocio')}
                                        <InputFilter
                                            value={filtroNegocio}
                                            onSearch={value => {
                                                setFiltroNegocio(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        {t('data')}
                                        <Datepicker
                                            displayFormat={FORMATO_DATA}
                                            useRange={false}
                                            asSingle={false}
                                            value={filtroData}
                                            onChange={newValue => {
                                                setFiltroData(newValue);
                                                setCurrentPage(1);
                                            }}
                                            inputClassName={`rounded-[8px] w-full mt-2 bg-gray-50 border border-gray-300 text-xs text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                                        />
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        {t('vendedor')}
                                        <SelectComponent
                                            options={representantes}
                                            value={filtroVendedor}
                                            onChange={e => {
                                                setFiltroVendedor(e);
                                                setCurrentPage(1);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('filtro')}
                                        />
                                    </th>

                                    <th scope="col" className=" py-3 w-80">
                                        {t('validado')}
                                        <div className="flex flex-row">
                                            <SelectComponent
                                                options={simNao}
                                                value={filtroValidado}
                                                onChange={e => {
                                                    setFiltroValidado(e);
                                                    setCurrentPage(1);
                                                }}
                                                noOptionsMessage={t('semopcoes')}
                                                placeholder={t('filtro')}
                                            />
                                            {filtrosAplicados() ? (
                                                <button
                                                    onClick={limparFiltros}
                                                    type="button"
                                                    className="flex items-center border-gray-300 text-gray-600 hover:text-blue-600 bg-gray-100 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] ml-2 text-xs  text-center dark:bg-gray-600 dark:text-white dark:hover:text-blue-500 dark:focus:ring-blue-800">
                                                    <FilterAltOffIcon />
                                                </button>
                                            ) : null}
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {questoes?.map(dados => {
                                    return (
                                        <tr
                                            className="odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 hover:border-2 border-b cursor-pointer dark:bg-gray-800 dark:border-gray-600 hover:border-amber-400 hover:dark:border-amber-400 "
                                            onClick={() => onRowClick(dados)}>
                                            <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                {dados.id}
                                            </th>
                                            <td className=" py-1">{dados.descricao}</td>
                                            <td className="px-6 py-1 w-74">{dados.cliente.nomeCliente}</td>
                                            <td className=" py-1">{dados.negocio.nome}</td>
                                            <td className="px-6 py-1">{moment(dados.dataCriacao).format(FORMATO_DATA)}</td>
                                            <td className=" py-1">{dados.representante.label}</td>
                                            <td className=" py-1">{dados.validado ? t('sim') : t('nao')}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        {semDados && !loading && <NotFound frase={t('semRegistos')} />}

                        {/* {totalLinhas === undefined && (
                      <NotFound frase={t('naoExistemClientes')} />
                  )} */}

                        {loading && (
                            <div className="flex flex-row mt-14 justify-center">
                                <>
                                    <Spinner />
                                </>
                            </div>
                        )}
                        <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                            <div>
                                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                    {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                    <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalLinhas / ITEMS_PER_PAGE)}</span>
                                </span>

                                <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalLinhas}</span>
                                <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                            </div>
                            {totalLinhas != 0 && <TablePagination total={totalLinhas} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />}
                        </nav>
                    </div>
                )}
            </div>
        </>
    );
}

export default Table;
